// Module
var code = " <div id=\"demo-full-height\" class=\"width-100 position-absolute top-to-bottom is-flex is-flex-direction-column\"> <div class=\"\"> Header </div> <div class=\"is-flex-grow-1 overflow-auto\"> Content <div class=\"bigger\"></div> </div> <div class=\"\"> Footer </div> </div> ";
// Exports
export default code;